import { Icon } from "@iconify/react";
import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

const DeleteSurvey = (props) => {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modalPopup modalConfirm"
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          <h3>
            <i>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.8833 6.3125C12.8833 6.3125 12.5213 10.8025 12.3113 12.6938C12.2113 13.5972 11.6533 14.1265 10.7393 14.1432C8.99994 14.1745 7.25861 14.1765 5.51994 14.1398C4.64061 14.1218 4.09194 13.5858 3.99394 12.6985C3.78261 10.7905 3.42261 6.3125 3.42261 6.3125"
                  stroke="#A2A9B0"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M13.8055 4.15999H2.50012"
                  stroke="#A2A9B0"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M11.627 4.15998C11.1037 4.15998 10.653 3.78998 10.5503 3.27732L10.3883 2.46665C10.2883 2.09265 9.94968 1.83398 9.56368 1.83398H6.74168C6.35568 1.83398 6.01701 2.09265 5.91701 2.46665L5.75501 3.27732C5.65234 3.78998 5.20168 4.15998 4.67834 4.15998"
                  stroke="#A2A9B0"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </i>
            <span>Delete Survey</span>{" "}
          </h3>
          <p>You are about to delete survey(s)</p>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Are you sure you want to delete survey(s)?</p>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn cta-primary-light" onClick={props.onHide}>
          Cancel
        </button>
        <button className="btn cta-primary me-2" onClick={props.onRemove}>
          Delete
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteSurvey;
